const routerUrl = {
    state: {
        urlName: window.location.pathname.split('/')[1] !== 'login' ? window.location.pathname.split('/')[1] : '' || window.sessionStorage.getItem('urlName') ||'coke',
    },
    mutations: {
        SET_URL_NAME: (state, urlName) => {
            state.urlName = urlName;
            window.sessionStorage.setItem('urlName', urlName);
        }
    },
    actions: {
        GetUrlName({state}) {
            return new Promise(resolve => {
                let title = '';
                let sourceType = '';
                switch (state.urlName) {
                    case 'coke':
                        title = '焦炭'
                        sourceType = '1'
                        break;
                    case 'steel':
                        title = '钢铁'
                        sourceType = '2'
                        break;
                    case 'ironstone':
                        title = '铁矿石'
                        sourceType = '4'
                        break;
                    case 'coal':
                        title = '煤炭'
                        sourceType = '3'
                        break;
                    case 'powerCoal':
                        title = '煤炭'
                        sourceType = '3'
                        break;
                    case 'methanol':
                        title = '甲醇'
                        sourceType = '5'
                        break;
                    case 'oilBenzene':
                        title = '芳烃'
                        sourceType = '6'
                        break;
                    case 'cokeBenzene':
                        title = '芳烃'
                        sourceType = '6'
                        break;
                    case 'caprolactam':
                        title = '芳烃'
                        sourceType = '6'
                        break;
                    case 'adipic':
                        title = '芳烃'
                        sourceType = '6'
                        break;
                    case 'styrene':
                        title = '芳烃'
                        sourceType = '6'
                        break;
                    case 'zetar':
                        title = '碳材料'
                        sourceType = '8'
                        break;
                    case 'anhydride':
                        title = '碳材料'
                        sourceType = '8'
                        break;
                    case 'asphalt':
                        title = '碳材料'
                        sourceType = '8'
                        break;
                    case 'needle':
                        title = '碳材料'
                        sourceType = '8'
                        break;
                    case 'petroleum':
                        title = '石油'
                        sourceType = '9'
                        break;
                    case 'hydrogen':
                        title = '氢能'
                        sourceType = '10'
                        break;
                    default:
                        title = '焦炭'
                        sourceType = '1'
                        break;
                }
                resolve({
                    title,
                    sourceType
                })
            })
        }
    },
}

export default routerUrl
